/* eslint-disable import/no-unresolved */
import {
    ApolloClient, InMemoryCache, makeVar, createHttpLink, from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { HttpStatusCodeEnum } from 'constants';
import {
    getAccessToken,
    getAuthorizationHeaderValue,
    getSelectedTenant,
    getSelectedTenantName,
    isAuthenticated,
    signOutUser,
} from '../views/Auth/AuthHelper';

const defaultTenant = parseInt(getSelectedTenant(), 10);
const defaultTenantName = getSelectedTenantName();

export const selectValueVar = makeVar({});
export const doneUploadingVar = makeVar(false);
export const isFileUploadingVar = makeVar(false);
export const getPreviousBatchVar = makeVar(false);
export const showBatchAlertVar = makeVar(false);
export const getUserInfoVar = makeVar({});
export const isLoggedInVar = makeVar(false);
export const isAuthenticatedVar = makeVar(false);
export const tenantIdVar = makeVar(defaultTenant || null);
export const tenantNameVar = makeVar(defaultTenantName || null);
export const showReportMenuVar = makeVar();
export const showDataReconVar = makeVar();
export const showDataReconMenusVar = makeVar(false);
export const activeDataReconMenuVar = makeVar();
export const renamedFileMessagesVar = makeVar('');

export const leftNavigationItemsVar = makeVar([]);
export const moduleIdVar = makeVar(null);
export const showCrossReportConfigVar = makeVar();
export const showConfigureDataSourceModalVar = makeVar(false);
export const dataSourceReportIdVar = makeVar(null);
export const currentLeftMenuVar = makeVar();
export const ruleSummaryPageNumberVar = makeVar(1);
export const ruleSummaryPageSizeVar = makeVar(10);
export const rulePassedVar = makeVar(false);
export const ruleFailedVar = makeVar(false);
export const ruleErrorVar = makeVar(false);

const httpLink = createHttpLink({
    uri: process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_GRAPHQL_API_URL
        : '/graphql',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (networkError) {
        console.log('Apollo networkError:', networkError.statusCode, networkError.message);

        // Only sign out on 401 UNAUTHORIZED
        // Skip if we're still on the callback/auth flow
        // if (
        //     networkError.statusCode === HttpStatusCodeEnum.UNAUTHORIZED
        //     && !window.location.pathname.includes('callback')
        //     && !window.location.search.includes('code=')
        // ) {
        //     console.log('401 detected, signing out...');
        //     signOutUser();
        // }
    }

    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            );
        });
    }
});

// Add to config.js authLink temporarily
const authLink = setContext((_, { headers }) => {
    const token = getAuthorizationHeaderValue();
    const accessToken = getAccessToken();

    // 🔍 Decode id_token to show which user this belongs to
    if (token) {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            console.log('🔍 LOGGED IN USER (from id_token):', payload.email || payload.preferred_username || payload.upn || payload.name);
        } catch (e) {
            console.log('🔍 Could not decode id_token');
        }
    }

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
          'x-access-token': accessToken ? `${accessToken}` : '',
        },
    };
});
const cache = new InMemoryCache();

const client = new ApolloClient({
    cache,
    link: from([authLink, errorLink, httpLink]),
    name: 'luna-frontend',
    version: '1',
    typePolicies: {
        Query: {
            fields: {
                selectValue: {
                    read() {
                        return selectValueVar();
                    },
                },
                doneUploading: {
                    read() {
                        return doneUploadingVar();
                    },
                },
                getUserInfo: {
                    read() {
                        return getUserInfoVar();
                    },
                },
                isAuthenticated: {
                    read() {
                        return isAuthenticatedVar();
                    },
                },
            },
        },
    },
});

export default client;